import React from 'react';

import { flush } from '@amplitude/analytics-browser';
import { css } from '@emotion/react';
import { NeutralColorToken, Type } from '@robinhood/design';

import UserCreationDisclosure from './UserCreationPage/UserCreationDisclosure';
import RobinhoodGoldCardLogo from 'src/assets/vectors/RobinhoodGoldCardLogo';
import { Event, track } from 'src/clients/tracking';
import Button from 'src/components/creditApplication/Button';
import GradientBackgroundLayout from 'src/components/creditApplication/GradientBackgroundLayout';
import { NavigationContext } from 'src/components/creditApplication/NavigationProvider';
import { LoginPageUrl } from 'src/constants/urls';

const LandingPage = () => {
  const { setCurrentPage } = React.useContext(NavigationContext);

  const onClickLogin = React.useCallback(() => {
    track(Event.RhWebCreditApplicationExistingUserLogin);
    flush();
    window.location.href = LoginPageUrl;
  }, []);

  const onClickCreateAccount = React.useCallback(() => {
    setCurrentPage('USER_CREATION');
  }, [setCurrentPage]);

  return (
    <GradientBackgroundLayout>
      <RobinhoodGoldCardLogo />
      <div css={textContainer}>
        {/* TODO (szhang): Support martina font */}
        <Type.Display font='nib' size='L'>
          Welcome to the Gold experience
        </Type.Display>
        <Type.Text size='M' color={NeutralColorToken.Fg2} overrideRootStyles={mt8}>
          Already a Robinhood customer?
        </Type.Text>
        <Button label='Log in to Apply' width='full' type='button' onClick={onClickLogin} overrideRootStyles={mt24} />
        <Type.Text size='M' color={NeutralColorToken.Fg2} overrideRootStyles={mt40}>
          or sign up and apply in minutes.
        </Type.Text>
        <Button
          label='Create account'
          width='full'
          type='button'
          variant='secondary'
          onClick={onClickCreateAccount}
          overrideRootStyles={mt16}
        />
      </div>
      <UserCreationDisclosure />
    </GradientBackgroundLayout>
  );
};

export default LandingPage;

const mt8 = css`
  margin-top: 8px;
`;

const mt16 = css`
  margin-top: 16px;
`;

const mt24 = css`
  margin-top: 24px;
`;

const mt40 = css`
  margin-top: 40px;
`;

const textContainer = css`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
